import Swiper from 'swiper/dist/js/swiper';
import 'swiper/dist/css/swiper.min.css';

export default class {
    constructor(selector, params) {
        this.$el = $(selector);
        this.initSwiper(params);
    }

    initSwiper(params) {
        this.swiper = new Swiper(this.$el.find('.swiper-container'), {
            loop: true,
            autoplay: {
                delay: 5000,
            },
            navigation: {
                prevEl: $(this.$el).find('.swiper-button-prev'),
                nextEl: $(this.$el).find('.swiper-button-next'),
                speed: 1500,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable:true,
            },
            ...params,
        })
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/components/slider.js